import { useIntl } from "react-intl";
import Loader from "react-loaders";
import FormLayout from "components/FormLayout";

export const SSOLayout = () => {
  const intl = useIntl();

  return (
    <FormLayout label={intl.messages["loginScene.login.ssoLoginLabel"]}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Loader />
      </div>
    </FormLayout>
  );
};
